import {Flex, Radio, Text} from '@chakra-ui/react';
import {PaymentCard} from '@eksab/features/profile/hooks/useMyCardsQuery';

import {useTranslate} from '@eksab/i18n';

import {MasterCardIcon, VisaIcon} from '../icons';

interface PaymentCardItemProps {
  card: PaymentCard;
  value: string;
}

export function PaymentCardItem({card, value}: PaymentCardItemProps) {
  const t = useTranslate();

  return (
    <Flex
      as="label"
      p="4"
      htmlFor={card.masked_pan}
      gap={{base: 3, lg: 6}}
      borderWidth="1px"
      w="full"
      rounded="md"
      cursor="pointer"
    >
      <Radio id={card.masked_pan} value={value} colorScheme="green" />

      <Flex w="full" align="center" justify="space-between" gap={{base: 3, lg: 6}}>
        {card.card_type === 'Visa' ? (
          <VisaIcon width={{base: 8, lg: 12}} height="auto" />
        ) : (
          <MasterCardIcon width={{base: 8, lg: 12}} height="auto" />
        )}

        <Text fontSize={{base: 'sm', lg: 'md'}} textAlign="end">
          {t('payment.method.cc.ending-in')}
          {card.masked_pan.substring(15)}
        </Text>
      </Flex>
    </Flex>
  );
}
